import { ui } from '@libs/domain';
import { colors } from '@libs/ui';
// Deep icon import (not the `@mui/icons-material` barrel), which trips EMFILE under vitest.
import Add from '@mui/icons-material/Add';
import { Divider, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { genMsg, useItemNames } from '@ps-smart-cp/ppfw-client';

/**
 * 「＋ 新規台帳『xxx』を作成」の一行。台帳の候補一覧と区切り線で分ける。
 *
 * <p>このコンポーネント自体は副作用を持たない。作成 API の呼び出しやメニューを閉じる処理は
 * {@link CreateSpaceFooterItemProps.onCreate} を渡す側の責務。
 */

interface CreateSpaceFooterItemProps {
  /** 作成対象の台帳名（検索ボックスの入力値）。 */
  name: string;
  /** クリック時の通知。実際の作成処理は呼び出し側が行う。 */
  onCreate: (name: string) => void;
}

function CreateSpaceFooterItem(props: CreateSpaceFooterItemProps) {
  const { name, onCreate } = props;
  const getLabelName = useItemNames(ui.labelNames);
  const trimmed = name.trim();

  if (!trimmed) {
    return null;
  }

  return (
    <>
      <Divider sx={{ borderColor: colors.gray }} />
      <ListItemButton
        id="global-space-switch-create"
        disableRipple
        onClick={() => onCreate(trimmed)}
        sx={{ py: '10px', gap: '4px', alignItems: 'flex-start' }}
      >
        <ListItemIcon sx={{ minWidth: '24px', flexShrink: 0, color: colors.seaGreen, mt: '2px' }}>
          <Add fontSize="small" />
        </ListItemIcon>
        <ListItemText
          primary={genMsg(getLabelName('newSpaceLabel'), trimmed)}
          sx={{ minWidth: 0 }}
          slotProps={{
            primary: {
              sx: {
                fontSize: '11px',
                overflowWrap: 'break-word',
                whiteSpace: 'normal',
              },
            },
          }}
        />
      </ListItemButton>
    </>
  );
}

export { CreateSpaceFooterItem };
